import { iPartProps, Part } from '@/Engine/Part';
import { Group, Object3D } from 'three';
import { $ } from '@/Engine/state';
import { iCaseComponentsResultItem } from '@/Interfaces/caseComponentsLib';
import { v3dMesh } from '@/Interfaces/common';
import { shelves } from '@/Constants/caseComponentsLib/shelves';
import { getMaxIndexSection } from '@/Engine/eventHandlers/libs/getHardSection';

export const shelfChpuHard: iCaseComponentsResultItem = {
    id: crypto.randomUUID(),
    prototypeId: 'sh_chpu_hard',
    indexPositionY: 0,
    isLeft: false,
    isDefaultHolder: true,
};

export class shelfCNCHard extends Part {
    holder?: Part|null;
    idSection = 1;
    idChangeSection = 1;
    parent?: Object3D;//секция _s1
    idGroup: number;

    constructor(props: iPartProps, idGroup: number) {
        super(props);
        this.idGroup = idGroup;
        this.parent = this.model;
    }
    join(modelParent?: Object3D|v3dMesh) {
        this.idSection = this.getNumberSection();
        this.idChangeSection = this.idSection;
        if (!modelParent) return;
        this.parent = modelParent;

        //не переобновляется obb секций (всегда обновл только для s1)
        //поэтому удаляем неиспользуемые obb
        this.obb = null;
        this._model.position.set(0, 0, 0);
        modelParent.add(this._model);
        this.idGroup = modelParent.userData?.parent?.idGroup;
    }
    createHolderChpu(parent: Group) {
        const shelf = shelfChpuHard;
        this.holder = $.toolChest?.createPartItem(shelf);
        if (!this.holder) return;
        parent?.add(this.holder.model);
    }
    deleteHolder() {
        this.model.children = this.model.children.filter(x => x !== this.holder?.model);
        this.holder?.model.removeFromParent();
        this.holder = null;
    }

    getNumberSection() {
        return +this._model.name.split('_s')[1];
    }
    changeModel(model?: Object3D, add?: boolean, parent?: Object3D) {
        if (!model) return;
        super.changeModel(model);
        const prototypeId = shelves
            .find(x => x.blenderName === model.name)?.id;
        if (prototypeId && this.prototypeId !== prototypeId) this.prototypeId = prototypeId;

        if (!add && this.getNumberSection() === 1) {
            this.idChangeSection = 1;
            if (!this.holder) this.createHolderChpu(this.model);
            this.parent = this.model;
            return;
        }
        if (add) {
            if (this.holder) this.deleteHolder();
            this.idSection = this.idChangeSection + 1;
            this.parent = parent;
        }
    }
    deleteLastSection() {
        const maxIndex = getMaxIndexSection(this.model);
        const section = $.toolChest?.shelfCNCHard
            .find(item => {
                if (this.model.children.map(x => x.uuid).includes(item._model.uuid) &&
                    item._model.name.includes('_s'+maxIndex)) {
                    return item?.model.userData.parent;
                }
            });
        $.toolChest?.removeComponent(section);
    }

    deleteChildren() {
        const childrenCNCHard = $.toolChest?.shelfCNCHard
            .filter(item => {
                if (this.model.children.map(x => x.uuid).includes(item._model.uuid)) {
                    return item?.model.userData.parent;
                }
            });
        childrenCNCHard?.forEach(x => $.toolChest?.removeComponent(x));
    }

    isChild(section: shelfCNCHard) {
        return this.model.children.find(x => x === section._model);
    }
    get raw(): iCaseComponentsResultItem {
        const res = super.raw;
        res.idGroup = this.idGroup;
        return res;
    }
}